// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "style/" + chunkId + "." + "fe5567527f04d4bc7ef2" + ".css";
};